<template>
	<header class="mb-5">
		<nk-meta v-if="context.meta">
			{{ context.meta }}
		</nk-meta>
		<nk-title v-if="context.titel" :size="titelSize()" :tag="titelTag()">
			{{ context.titel }}
		</nk-title>
		<nk-text v-if="context.einleitung" size="md">
			{{ context.einleitung }}
		</nk-text>
	</header>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.meta
 * @prop {string} context.titel
 * @prop {string} options.titelSize
 * @prop {string} options.titelTag
 * @prop {string} context.einleitung
 */
export default {
	name: 'NkTemplateHeader',
	mixins: [TemplatesDefault],

	methods: {
		titelSize() {
			return this.options.titelSize ? this.options.titelSize : '4xl';
		},
		titelTag() {
			return this.options.titelTag ? this.options.titelTag : 'h1';
		},
	},
};
</script>
